<script>
import {
  orgComputed,
  orgMethods
} from '@state/helpers';

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...orgMethods
  },
  computed: {
    ...orgComputed,
    color() {
      return process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878' ? '#FF7F50' : this.primaryColor;
    },
    colors() {
      return {
        '--color':  this.primaryColor,
        // 'background': process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878' ? '#FF7F50' : this.primaryColor
      }
    }
  },
};
</script>

<template>
  <button
    :class="type"
    :disabled="disabled"
    :style="colors"
    :type="type"
    v-on="$listeners"
    @click="$emit('event')"
  >
    <slot />
  </button>
</template>

<style lang="scss" scoped>
@import '@design';

button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

.small {
  background: var(--color) !important;
  border: none;
  border-radius: 38px;
  color: white;
  cursor: pointer;
  font-family: 'Roboto', serif;
  font-size: 17px;
  font-weight: 500;
  height: 56px;
  opacity: 1;
  outline: none;
  padding: 0;
  -webkit-transition-duration: 0.3s;
  width: 160px;
}

.large {
  background: var(--color) !important;
  border: none;
  border-radius: 38px;
  color: white;
  cursor: pointer;
  font-family: 'Roboto', serif;
  font-size: 17px;
  height: 56px;
  letter-spacing: 0.01em;
  line-height: 1;
  opacity: 1;
  outline: none;
  padding: 20px 0;
  text-align: center;
  text-decoration: none;
  text-transform: capitalize;
  -webkit-transition-duration: 0.3s;
  width: 100%;
}

.small-transparent {
  background: transparent;
  border: 1px solid white;
  border-radius: 38px;
  color: white;
  cursor: pointer;
  font-family: 'Roboto', serif;
  font-size: 17px;
  font-weight: 500;
  height: 56px;
  opacity: 1;
  outline: none;
  padding: 0;
  -webkit-transition-duration: 0.3s;
  width: 235px;
}

.large-transparent {
  background: transparent;
  border: 1px solid white;
  border-radius: 38px;
  color: white;
  cursor: pointer;
  font-family: 'Roboto', serif;
  font-size: 17px;
  height: 56px;
  letter-spacing: 0.01em;
  line-height: 1;
  opacity: 1;
  outline: none;
  padding: 0;
  text-align: center;
  text-decoration: none;
  text-transform: capitalize;
  -webkit-transition-duration: 0.3s;
  width: 100%;
}

.button {
  &.btn-secondary {
    background-color: transparent;
    border: 0.28rem solid var(--color) !important;
    border-radius: 999rem;
    color: var(--color) !important;
    font-size: 1.4rem;
    font-weight: 500;
    svg {
      fill: var(--color) !important;
      path {
        fill: var(--color) !important;
      }
    }
    &:hover {
      background-color: var(--color) !important;
      color: $color-button-text;
      svg {
        fill: $color-off-white;
        path {
          fill: $color-off-white;
        }
      }
    }
  }
  &.btn-primary {
    background: var(--color) !important;
    background-color: var(--color) !important;
    border-color: var(--color) !important;
    font-size: 1.4rem;
    font-weight: 500;
    &:hover {
      background: darken($color-button-bg, 10);
      color: $color-button-text;
    }
  }
}
</style>
